/* eslint-disable no-unused-vars */
import api from 'configs/api';
import {
  IEquipment,
  IEquipmentFilterData,
  IEquipmentFilterTreeData,
  IEquipmentGrid,
  IEquipmentGridData,
  IEquipmentGridTotalRequest,
  IEquipmentGridParamsRequest,
  IEquipmentListValues,
  IEquipmentOptions,
  IEquipmentValues,
  IExportEquipment,
} from 'interfaces/Equipment';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { IRequestResponse } from 'interfaces/RequestResponse';

const endpointUrl = 'equipment';

export const postEquipmentTreeFilterPlanning = async params => {
  const url = `${endpointUrl}/tree/filter/planning`;
  const { data } = await api.post<IRequestResponse<IEquipmentFilterTreeData>>(
    url,
    params,
  );
  return data;
};

export const postEquipmentTreeFilterInspection = async params => {
  const url = `${endpointUrl}/tree/filter/inspection`;
  const { data } = await api.post<IRequestResponse<IEquipmentFilterTreeData>>(
    url,
    params,
  );
  return data;
};

export const postEquipmentFilter = async (qsparams, params) => {
  const url = `${endpointUrl}/filter?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IEquipmentFilterData>>(
    url,
    params,
  );
  return data;
};

export const getEquipment = async (id?: string | number) => {
  const url = id ? `${endpointUrl}/${id}` : `${endpointUrl}/`;
  const { data } = await api.get<IRequestListResponse<IEquipment>>(url);
  return data;
};

export const postEquipmentOptions = async params => {
  const url = `${endpointUrl}/filter/description-and-installation`;
  const { data } = await api.post<IRequestListResponse<IEquipmentOptions>>(
    url,
    params,
  );
  return data;
};

export const postEquipmentOptionsByInstallation = async params => {
  const url = `${endpointUrl}/tree/filter/installation`;
  const { data } = await api.post<IRequestResponse<IEquipmentFilterTreeData>>(
    url,
    params,
  );
  return data;
};

export const postEquipmentTreeOptions = async (
  qsparams: string,
  params: { installationIds?: (number | string)[]; description?: string },
) => {
  const url = `${endpointUrl}/tree/filter/add-equipment?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IEquipmentFilterTreeData>>(
    url,
    params,
  );
  return data;
};

export const postAllEquipmentOptions = async (qsparams, params) => {
  const url = `${endpointUrl}/filter/all/installation?${qsparams}`;
  const { data } = await api.post<IRequestResponse<IEquipmentFilterData>>(
    url,
    params,
  );
  return data;
};

export const postEquipmentAllOptions = async params => {
  const url = `${endpointUrl}/filter/installation`;
  const { data } = await api.post<IRequestListResponse<IEquipmentOptions>>(
    url,
    params,
  );
  return data;
};

export const getEquipmentLocation = async (id?: string | number) => {
  const url = `${endpointUrl}/location/${id}`;
  const { data } = await api.get<IRequestListResponse<IEquipmentValues>>(url);
  return data;
};

export const getEquipmentInstallationCode = async (id?: string | number) => {
  const url = `${endpointUrl}/installation-code/${id}`;
  const { data } = await api.get<IRequestListResponse<IEquipmentValues>>(url);
  return data;
};

export const getEquipmentDescription = async (
  qsparams,
  id?: string | number,
) => {
  const url = `${endpointUrl}/description/${id}?${qsparams}`;
  const { data } = await api.get<IRequestResponse<IEquipmentListValues>>(url);
  return data;
};

export const getEquipmentManufacturer = async (id?: string | number) => {
  const url = `${endpointUrl}/manufacturer/${id}`;
  const { data } = await api.get<IRequestListResponse<IEquipmentValues>>(url);
  return data;
};

export const postAddEquipment = async params => {
  const url = `${endpointUrl}/add`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const putUpdateEquipment = async (
  id: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: Record<string, any>,
) => {
  const url = `${endpointUrl}/update/${id}`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const postExportEquipment = async params => {
  const url = `${endpointUrl}/grid/excel`;
  const { data } = await api.post<IExportEquipment>(url, params);
  return data;
};

export const getEquipmentGridData = async ({
  qsparams,
  params,
  isRootLevel,
}: IEquipmentGridParamsRequest) => {
  const url = isRootLevel
    ? `${endpointUrl}/grid?${qsparams}`
    : `${endpointUrl}/grid-level?${qsparams}`;
  const { data } = await api.post<
    IRequestResponse<IEquipmentGridData<IEquipmentGrid[]>>
  >(url, params);
  return data;
};

export const postGridTotal = async ({ params }: IEquipmentGridTotalRequest) => {
  const url = `${endpointUrl}/grid/total`;
  const { data } = await api.post<IRequestResponse<number>>(url, params);
  return data;
};

export const putGridInactivateEquipment = async (params: {
  equipmentIds: number[];
}) => {
  const url = `${endpointUrl}/inactivate`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const putGridActivateEquipment = async (params: {
  equipmentIds: number[];
}) => {
  const url = `${endpointUrl}/activate`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};

export const postBopTypes = async params => {
  const url = `${endpointUrl}/filter/bopTypes`;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data } = await api.post<any>(url, params);
  return data;
};

export const postEquipmentTree = async params => {
  const url = `${endpointUrl}/tree/filter/installationBop`;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data } = await api.post<any>(url, params);
  return data;
};

export const postExecuterInstallation = async params => {
  const url = `${endpointUrl}/filter/executor-and-installation`;
  const { data } = await api.post<IEquipmentFilterTreeData>(url, params);
  return data;
};
